module.exports = __webpack_public_path__ + "static/media/I_wa_ui.7847a1ac.png";